"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

const styled_components_1 = __importDefault(require("styled-components"));

const theme_1 = require("../../theme/theme");

const inventory_1 = require("../../theme/inventory");

exports.Container = styled_components_1.default.div`
  width: 100%;
  height: 100%;
  background-color: ${theme_1.mainTheme.colors.primary_100};
  border-radius: 3px;
  padding: ${theme_1.mainTheme.spacing[12]};
  line-height: ${theme_1.mainTheme.lineHeights[18]};
  text-align: center;
  font-family: ${theme_1.mainTheme.fontNames[inventory_1.GeneralFontNames.roboto_sana_serif]};
  font-weight: ${theme_1.mainTheme.fontWeights[inventory_1.GeneralFontWeights.regular]};
  font-size: ${theme_1.mainTheme.fontSizes[12]};
  color: ${theme_1.mainTheme.colors.black_main};
  ${props => props.stylesOverride};
`;